howspace.login.loginApp = (() => {
    'use strict';

    if (!real.dom.$html.hasClass('login-app')) {
        return {};
    }

    const emailInput = $('#email');

    emailInput.on('input', real.input.validateEmail);
    emailInput.on('blur', real.input.validateEmailBlur);

    emailInput.on('input', function(_e) {
        emailInput.removeClass('is-invalid');
        $('.login-btn, .register-btn').prop('disabled', this.value.trim() === '');
    });

    emailInput.on('keyup', function(e) {
        if (e.key === 'Enter') {
            $('.login-btn:not([disabled])').trigger('click');
            $('.register-btn:not([disabled])').trigger('click');
        }
    });

    $('.login-btn').on('click', e => {
        const btn = $(e.currentTarget);

        real.button.loading(btn, $('.login-form'));

        const urlParams = new URLSearchParams(window.location.search);
        const path = urlParams.get('path'); // Either the path as string or null if not set

        const dataPayload = {
            email : $('#email').val(),
            path : path
        };

        const token = $('#cf-token').val();
        if (token) {
            dataPayload['cf-token'] = token;
        }

        real.ajax.json(real.baseUri + '/index/login', {
            type : 'POST',
            data : JSON.stringify(dataPayload),
            waitForWebsocket : false,
            success : function(response) {
                if (response.location) {
                    window.location = response.location;
                    return;
                }

                const loginForm = $('.login-form');
                const loginLinkSuccess = $('.login-link-success');

                loginForm.hide();
                loginLinkSuccess.show();
                let loginLinkBox = $('.login-form');
                const animHeight = loginLinkBox.height();
                loginForm.show();
                loginLinkSuccess.hide();

                loginLinkBox.velocity({
                    height : animHeight
                }, {
                    duration : 'fast',
                    complete : function() {
                        requestAnimationFrame(function() {
                            loginLinkBox.css('height', '');
                        });
                    }
                });

                loginForm.velocity('fadeOut', {
                    duration : 'fast',
                    complete : function() {
                        loginLinkBox.removeClass('no-title');
                        loginLinkSuccess.velocity('fadeIn', {
                            duration : 'fast',
                            display : 'grid',
                            complete : function() {
                                loginLinkBox.removeClass('bg-white');
                            }
                        });
                    }
                });
            },
            logError : false,
            showErrorNotification : false,
            error : function(response) {
                let reset = true;
                let invalidEmailFeedback = $('.invalid-feedback');
                invalidEmailFeedback.html(howspace.translate('login_error_unknown_error'));

                real.ajax.loopErrors(response, function(error) {
                    switch(error.key) {
                        case 'bad_request_email_needs_captcha':
                            if (!(typeof turnstile === 'object' && typeof turnstile.reset === "function" && typeof turnstile.render === "function")) {
                                // Abort if turnstile isn't properly loaded
                                return;
                            }

                            // Override default error
                            invalidEmailFeedback.html(howspace.translate('login_error_captcha'));

                            const widgetLocator = '#cf-turnstile';
                            const widgetEle = $(widgetLocator);

                            if (widgetEle.data('wid')) {
                                // Turnstile is already rendered, re-trigger captcha.
                                turnstile.reset(widgetEle.data('wid'));
                            } else {
                                // Render and trigger turnstile
                                const widgetId = turnstile.render(widgetLocator, {
                                    sitekey: widgetEle.data('sitekey'),
                                    callback: (tokenResponse) => {
                                        const token = $('#cf-token');
                                        if (token.val()) {
                                            // Block recursing more than once.
                                            return;
                                        }
                                        token.val(tokenResponse);
                                        btn.click(); // Indirect recursion
                                    },
                                    'error-callback': () => {
                                        invalidEmailFeedback.html(howspace.translate('login_error_captcha_failed'));
                                        howspace.login.resetLoginButton(btn);
                                    },
                                });
                                widgetEle.dataAndAttr('wid', widgetId);
                            }

                            reset = false;
                            break;

                        case 'not_found' :
                            invalidEmailFeedback.html(howspace.translate('login_error_no_user_with_email'));
                            break;

                        case 'bad_request_resent_loginlink_not_allowed' :
                            invalidEmailFeedback.html(howspace.translate('login_error_login_not_allowed'));
                            break;

                        case 'bad_request_registration_not_allowed' :
                            invalidEmailFeedback.html(howspace.translate('login_error_registration_not_allowed'));
                            break;

                        case 'bad_request_invalid_json_payload' :
                            invalidEmailFeedback.html(howspace.translate('login_error_invalid_json_payload'));
                            break;

                        case 'bad_request_email_missing' :
                            invalidEmailFeedback.html(howspace.translate('login_error_email_missing'));
                            break;

                        case 'bad_request_email_invalid' :
                            invalidEmailFeedback.html(howspace.translate('login_error_email_invalid'));
                            break;

                        case 'bad_request_email_invalid_email_domain_denied' :
                            invalidEmailFeedback.html(howspace.translate('login_error_email_invalid_email_domain_not_whitelisted'));
                            break;

                        case 'bad_request_email_invalid_email_denied' :
                            invalidEmailFeedback.html(howspace.translate('login_error_invalid_email_denied'));
                            break;

                        case 'login_error_user_amount_exceeded_error' :
                            invalidEmailFeedback.html(howspace.translate('login_error_user_amount_exceeded', { max : real.dom.$body.data('workspace-max-users')}));
                            break;

                        case 'too_many_registration_requests' :
                            invalidEmailFeedback.html(howspace.translate('login_error_too_many_registration_requests'));
                            break;
                    }
                });

                if (reset) {
                    howspace.login.resetLoginButton(btn);
                }
            }
        });
    });

    return {};
})();
